import { useQuery } from '@tanstack/react-query';
import { getConfig } from '../utils/config';
import { getFilters } from '../api/filters';
import { IProductData } from '../types';

const pimLanguage = getConfig('pim_language', 'en');
const cmsNativeLanguage = getConfig('cms_native_language', 'EN-EN');

export function useAvailableFilters(productFilterData?: IProductData) {
  const productIds = productFilterData?.prefilter?.df_tagging_product_id?.map(Number);
  const variants =
    productFilterData?.variants && productFilterData.variants.length > 0
      ? productFilterData.variants
      : undefined;

  const { data, isLoading, isError } = useQuery({
    queryKey: ['available-filter-request'],
    queryFn: async () => {
      return await getFilters(cmsNativeLanguage, pimLanguage, productIds, variants);
    },
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  return [data?.data?.filter, isLoading, isError];
}
